import * as Caml_obj from "bs-platform/lib/es6/caml_obj.js";
import * as Caml_array from "bs-platform/lib/es6/caml_array.js";

function concordant(x0, x1) {
  var c = 0;

  for (var i = 0, i_finish = x0.length - 2 | 0; i <= i_finish; ++i) {
    for (var j = i + 1 | 0, j_finish = x0.length - 1 | 0; j <= j_finish; ++j) {
      if (i !== j && (Caml_obj.caml_lessthan(Caml_array.caml_array_get(x0, i), Caml_array.caml_array_get(x0, j)) && Caml_obj.caml_lessthan(Caml_array.caml_array_get(x1, i), Caml_array.caml_array_get(x1, j)) || Caml_obj.caml_greaterthan(Caml_array.caml_array_get(x0, i), Caml_array.caml_array_get(x0, j)) && Caml_obj.caml_greaterthan(Caml_array.caml_array_get(x1, i), Caml_array.caml_array_get(x1, j)))) {
        c = c + 1 | 0;
      }
    }
  }

  return c;
}

function discordant(x0, x1) {
  var c = 0;

  for (var i = 0, i_finish = x0.length - 2 | 0; i <= i_finish; ++i) {
    for (var j = i + 1 | 0, j_finish = x0.length - 1 | 0; j <= j_finish; ++j) {
      if (i !== j && (Caml_obj.caml_lessthan(Caml_array.caml_array_get(x0, i), Caml_array.caml_array_get(x0, j)) && Caml_obj.caml_greaterthan(Caml_array.caml_array_get(x1, i), Caml_array.caml_array_get(x1, j)) || Caml_obj.caml_greaterthan(Caml_array.caml_array_get(x0, i), Caml_array.caml_array_get(x0, j)) && Caml_obj.caml_lessthan(Caml_array.caml_array_get(x1, i), Caml_array.caml_array_get(x1, j)))) {
        c = c + 1 | 0;
      }
    }
  }

  return c;
}

function kendall_tau(x0, x1) {
  var a = concordant(x0, x1);
  var b = discordant(x0, x1);
  var n = x0.length;
  return 2 * (a - b) / (n * (n - 1));
}

export { concordant, discordant, kendall_tau };
/* No side effect */